import { Thumbnail } from '../../partials/image/image.types';

export const CLIP_PATH_SMALL = 'clipPathSmall';
export const CLIP_PATH_LARGE = 'clipPathLarge';

export interface Author {
  name: string;
  link?: string;
  image?: Thumbnail | null;
  bio?: string;
}
